import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import classNames from 'classnames';
import CreditReportComponent from './components/CreditReport';
import BusinessIdentityComponent from './components/BusinessIdentity';
import CompanyInfoTabTitle from './components/TabTitle';

import './styles.less';

const I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.subPages.companyInfo';

const CompanyInfo = ({ companyInfoData, openAddressModal }) => {
  const { t: translate } = useTranslation();
  const [source, setSource] = useState('kybCreditReport');

  return (
    <section className="KYB-company-info">
      <CompanyInfoTabTitle companyName={companyInfoData.companyName} />
      <div className="select-sources">
        <span>{translate(`${I18N_BASE_PATH}.chooseSource`, 'Choose source:')}</span>
        <div className="wrapper-button-sources">
          <button
            type="button"
            className={classNames(
              { 'source-selected': source === 'kybCreditReport' },
              { 'source-unselected': source !== 'kybCreditReport' }
            )}
            onClick={() => setSource('kybCreditReport')}
          >
            Credit report
          </button>
          <button
            type="button"
            onClick={() => setSource('sayari')}
            className={classNames(
              { 'source-selected': source === 'sayari' },
              { 'source-unselected': source !== 'sayari' }
            )}
          >
            Business identity
          </button>
        </div>
      </div>
      {source === 'kybCreditReport' ? (
        <CreditReportComponent
          openAddressModal={openAddressModal}
          creditReportData={companyInfoData.creditReport}
        />
      ) : (
        <BusinessIdentityComponent
          businessIdentityData={companyInfoData.businessIdentity}
        />
      )}
    </section>
  );
};

export default CompanyInfo;
